import { useContext, type ComponentProps } from 'react';
import { ThemeContext } from 'styled-components';
import LandlineIcon from './LandlineIcon';

/** Landline glyph for a call that has both a primary and a secondary location. */
export default function AssociatedLandlineIcon(
  props: ComponentProps<typeof LandlineIcon>,
) {
  const theme = useContext(ThemeContext);
  return <LandlineIcon {...props} color={theme?.colors?.lightWarning} />;
}
